import { render, staticRenderFns, recyclableRender, components } from "./withdrawal-details.vue?vue&type=template&id=58ec31c0&scoped=true&"
var renderjs
import script from "./withdrawal-details.vue?vue&type=script&lang=js&"
export * from "./withdrawal-details.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./withdrawal-details.vue?vue&type=style&index=1&id=58ec31c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec31c0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/withdrawal-details/withdrawal-details.vue"
export default component.exports